import React from 'react';
import { Linkedin, Twitter, Instagram } from 'lucide-react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <Linkedin size={18} />, href: '#', label: 'LinkedIn' },
    { icon: <Twitter size={18} />, href: '#', label: 'Twitter' },
    { icon: <Instagram size={18} />, href: '#', label: 'Instagram' },
  ];

  return (
    <footer className="footer-minimal">
      <div className="section-container">
        <div className="footer-content">
          <div className="footer-brand">
            <a href="/" className="logo-bravi">
              <img src="/logo.png" alt="Aven Talent Advisory" className="logo-img" />
              <span>
                Aven <span className="logo-suffix">Talent Advisory</span>
              </span>
            </a>
          </div>

          <div className="footer-contact">
            <a href="mailto:info@aventalentadvisory.com" className="footer-email">
              info@aventalentadvisory.com
            </a>
          </div>

          <div className="footer-social">
            {socialLinks.map((social, i) => (
              <a key={i} href={social.href} className="social-icon" aria-label={social.label}>
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Aven Talent Advisory LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
